import { ReactNode } from "react";
import styled from "styled-components";
import { FieldLabel } from "components/voc";
import BtnDelete from "assets/images/btn_file_delete.png";

type FormAreaProps = React.HTMLAttributes<HTMLDivElement> & {
  fieldLabelText?: string;
  mandatory?: boolean;
  noti?: string;
  children: ReactNode;
};

const FormAreaWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 2rem;

  .txt_label {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 1.2rem;
    font-weight: 700;
    line-height: 2.2rem;
  }
  .txt_label::before {
    position: absolute;
    top: 0.8rem;
    left: 0;
    width: 0.6rem;
    height: 0.6rem;
    background-color: #000;
    border-radius: 100%;
    content: "";
  }
  .txt_label .txt_em {
    font-size: 1.4rem;
    color: #e10032;
    font-weight: 400;
  }

  .btn_select_bottomsheet {
    position: absolute;
    bottom: 0.4rem;
    right: 0;
    min-width: 6rem;
    height: 3rem;
  }
  .list_time {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .list_time li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4rem;
    height: 3.8rem;
    background-color: #454557;
    border: 1px solid #dadada;
    color: #fff;
    font-size: 1.3rem;
    line-height: 1.6rem;
    font-weight: 700;
    text-align: center;
  }
  .list_time li + li {
    margin-left: 0.3rem;
  }
  .input {
    display: block;
    width: 100%;
    padding: 1.4rem 1.6rem;
    border: 1px solid #a8b2ba;
    border-radius: 0.8rem;
    font-family: "Pretendard", sans-serif;
  }
  .input::-moz-placeholder {
    color: #c9c9c9;
  }
  .input::placeholder {
    color: #c9c9c9;
  }
  .textarea {
    min-height: 11rem;
    padding: 1.5rem 1.6rem 1.9rem;
    border: 1px solid #a8b2ba;
    border-radius: 0.8rem;
    font-family: "Pretendard", sans-serif;
    box-sizing: border-box;
  }
  .textarea::-moz-placeholder {
    color: #c9c9c9;
  }
  .textarea::placeholder {
    color: #c9c9c9;
  }
  .form_file {
    position: absolute;
    top: 0;
    right: 0;
  }
  .form_file input[type="file"] {
    opacity: 0;
    position: absolute;
    height: 0;
    width: 0;
  }
  .form_file label {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0.6rem 1.2rem;
    border: 1px solid #c8d2e0;
    border-radius: 0.5rem;
    color: #454557;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
  .form_file + .form_validation {
    margin-top: 0;
  }
  .list_file {
    order: 1;
  }
  .list_file li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }
  .list_file .filename {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.4rem;
  }
  .list_file .txt {
    display: inline-block;
    max-width: 20rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .list_file .btn_delete_file {
    flex-shrink: 0;
    width: 2.2rem;
    height: 2.2rem;
    background: url(${BtnDelete}) no-repeat center;
    background-size: 2.2rem;
  }
  .form_validation {
    margin-top: 1rem;
  }
  .form_validation .txt_noti {
    color: #8f8f8f;
    font-size: 1.3rem;
    line-height: 1.6rem;
    letter-spacing: -0.1rem;
  }
  .form_validation .txt_noti::before {
    content: "※ ";
  }
`;

const FormArea = ({ children, fieldLabelText, mandatory, noti, ...props }: FormAreaProps) => {
  return (
    <>
      <FormAreaWrapper {...props}>
        {fieldLabelText && <FieldLabel mandatory={mandatory}>{fieldLabelText}</FieldLabel>}
        {children}
        {noti && (
          <div className="form_validation">
            <p className="txt_noti">{noti}</p>
          </div>
        )}
      </FormAreaWrapper>
    </>
  );
};

export default FormArea;
